import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ProgressToastService } from '../../../services/progress-toast.service';
import { ProgressToastsItemComponent } from '../progress-toasts-item/progress-toasts-item.component';

@Component({
  selector: 'app-progress-toasts',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, ProgressToastsItemComponent],
  templateUrl: './progress-toasts.component.html',
  styleUrl: './progress-toasts.component.scss',
})
export class ProgressToastsComponent {
  private progressToastService = inject(ProgressToastService);
  public toasts$ = this.progressToastService.toasts$;
}
